import React, { useEffect, useState } from "react";
import InsightTable from "../InsightTable";
import { transformResultsToTableData } from "../../../../services/commonService";

function CustomerOverlapRiskZones({ customerOverlapRiskZones }) {
  const [tabData, setTabData] = useState([]);

  const actions = [
    // { type: "chart", title: "Chart", onClick: () => {} },
    { type: "conversation", title: "Conversation", onClick: () => {} },
    { type: "mindMap", title: "Mind Map", onClick: () => {} },
    { type: "download", title: "Download", onClick: () => {} },
  ];

  // const dummyData = [
  //   {
  //     customer: "a",
  //     segment: "b",
  //     served_by: "c",
  //     deal_types: "d",
  //     overlap_risk_level: "e",
  //     recommendation: "e",
  //     served_by_positive_insight: "c",
  //     served_by_negative_insight: "c",
  //     served_by_recent_development: "c",
  //     deal_types_positive_insight: "d",
  //     deal_types_negative_insight: "d",
  //     deal_types_recent_development: "d",
  //     overlap_risk_level_positive_insight: "e",
  //     overlap_risk_level_negative_insight: "e",
  //     overlap_risk_level_recent_development: "e",
  //     recommendation_positive_insight: "e",
  //     recommendation_negative_insight: "e",
  //     recommendation_recent_development: "e",
  //   },
  //   {
  //     customer: "a",
  //     segment: "b",
  //     served_by: "c",
  //     deal_types: "d",
  //     overlap_risk_level: "e",
  //     recommendation: "e",
  //     served_by_positive_insight: "c",
  //     served_by_negative_insight: "c",
  //     served_by_recent_development: "c",
  //     deal_types_positive_insight: "d",
  //     deal_types_negative_insight: "d",
  //     deal_types_recent_development: "d",
  //     overlap_risk_level_positive_insight: "e",
  //     overlap_risk_level_negative_insight: "e",
  //     overlap_risk_level_recent_development: "e",
  //     recommendation_positive_insight: "e",
  //     recommendation_negative_insight: "e",
  //     recommendation_recent_development: "e",
  //   },
  //   {
  //     customer: "a",
  //     segment: "b",
  //     served_by: "c",
  //     deal_types: "d",
  //     overlap_risk_level: "e",
  //     recommendation: "e",
  //     served_by_positive_insight: "c",
  //     served_by_negative_insight: "c",
  //     served_by_recent_development: "c",
  //     deal_types_positive_insight: "d",
  //     deal_types_negative_insight: "d",
  //     deal_types_recent_development: "d",
  //     overlap_risk_level_positive_insight: "e",
  //     overlap_risk_level_negative_insight: "e",
  //     overlap_risk_level_recent_development: "e",
  //     recommendation_positive_insight: "e",
  //     recommendation_negative_insight: "e",
  //     recommendation_recent_development: "e",
  //   },
  // ];

  useEffect(() => {
    const tableData = transformResultsToTableData(customerOverlapRiskZones);
    setTabData(tableData);
  }, [customerOverlapRiskZones]);

  const tableColumns = [
    // { id: "customer", label: "Customer" },
    // { id: "segment", label: "Segment" },
    { key: "served_by", label: "Served By" },
    { key: "deal_types", label: "Deal Types" },
    { key: "overlap_risk_level", label: "Overlap Risk Level" },
    { key: "recommendation", label: "Recommendation" },
  ];

  return (
    <InsightTable
      title="Customer Overlap Risk Zones"
      subtitle="Spot customers served by multiple competitors and assess HB Fuller’s risk of account erosion or displacement."
      data={tabData}
      metrics={tableColumns}
      rowIdentifier={["customer", "segment"]}
      actions={actions}
    />
  );
}

export default CustomerOverlapRiskZones;
